/**
 * Patient note lifecycle helpers (#2244) — pure module (no RN imports) so
 * the delete-optimism contract is browserless-testable. Policy: notes are
 * patient-authored free text with full CRUD including hard delete
 * (contract + live-verified); no server-side soft-delete or versioning.
 */

export function removePatientNote<T extends { id: string }>(
  notes: readonly T[] | undefined,
  noteId: string,
): T[] {
  return (notes ?? []).filter((note) => note.id !== noteId);
}
